import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "./App.vue?vue&type=style&index=0&id=7bec19a1&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\p-okuda\\okuda\\localRepository\\auto-sdms\\Web\\Server\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bec19a1"]])

export default __exports__